import React from "react";
// import { Link } from "react-router-dom";
import templeJson from "../../config/temple.json";
import FullCalenderPanchangDT from "./fullCalenderPanchangDT";
import FullCalenderPanchangSVT from "./fullCalenderPanchangSVT";

function FullCalendarPanchang() {
  return (
    <>
      {templeJson["Panchangam"].style === 1 ? (
        <FullCalenderPanchangDT />
      ) : (
        <FullCalenderPanchangSVT />
      )}
    </>
  );
}

export default FullCalendarPanchang;
